import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.log.policy');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-log-policy',
template: templateSource || '',
    styles: [``],
})
export class PageKieraLogPolicyComponent implements OnInit {
    public loading: boolean = false;
    public saving: boolean = false;
    public running: boolean = false;
    public dirty: boolean = false;
    public error: string = '';
    public message: string = '';
    public targets: any[] = [];
    public options: any[] = [];
    public policy: any = {};
    public enabled: any = {};
    public timelineEvents: any[] = [];
    public timelineEventEnabled: any = {};
    public scheduleTime: string = '00:00';
    public lastCleanup: any = {};
    public viewerOpen: boolean = false;
    public viewerLoading: boolean = false;
    public previewLoading: boolean = false;
    public viewerError: string = '';
    public previewError: string = '';
    public viewerTarget: any = null;
    public viewerTargetKey: string = '';
    public viewerStorages: any[] = [];
    public activeStorage: any = null;
    public activeFile: any = null;
    public preview: any = null;
    public previewMode: string = 'structured';
    public previewFormat: string = '';
    public previewRows: any[] = [];
    public previewColumns: string[] = [];
    public viewerStoragesCollapsed: boolean = false;
    public viewerFilesCollapsed: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    private callApi(name: string, payload: any = {}) {
        return wiz.call(name, payload);
    }

    public async load() {
        this.loading = true;
        this.error = '';
        this.message = '';
        await this.service.render();

        const { code, data } = await this.callApi("list");
        if (code === 200) {
            this.targets = data?.targets || [];
            this.options = data?.options || [];
            this.policy = { ...(data?.policy?.policies || {}) };
            this.enabled = { ...(data?.policy?.enabled || {}) };
            this.timelineEvents = data?.timeline_events || [];
            this.timelineEventEnabled = { ...(data?.policy?.timeline_events || {}) };
            this.scheduleTime = data?.policy?.schedule_time || '00:00';
            this.lastCleanup = data?.last_cleanup || {};
            this.dirty = false;
        } else {
            this.error = data?.message || data || this.translate.instant('page.log_policy.load_failed');
        }

        this.loading = false;
        await this.service.render();
    }

    public markDirty() {
        this.dirty = true;
        this.message = '';
    }

    public canToggleCollection(target: any) {
        return target?.key !== 'relay_groups';
    }

    private resolveTargetKey(target: any) {
        return String(target?.key || target?.target_key || target?.id || '').trim();
    }

    private activateDefaultStorage() {
        this.activeStorage = this.viewerStorages.find((item: any) => item.kind === 'file' && item.files?.length > 0)
            || this.viewerStorages[0]
            || null;
    }

    public async openViewer(target: any) {
        const targetKey = this.resolveTargetKey(target);
        if (!targetKey) return;
        this.viewerOpen = true;
        this.viewerLoading = true;
        this.previewLoading = false;
        this.viewerError = '';
        this.previewError = '';
        this.viewerTarget = target;
        this.viewerTargetKey = targetKey;
        this.viewerStorages = [];
        this.activeStorage = null;
        this.activeFile = null;
        this.viewerStoragesCollapsed = false;
        this.viewerFilesCollapsed = false;
        this.clearPreview();
        await this.service.render();

        const connectedStorages = Array.isArray(target?.storages) ? target.storages : [];
        if (connectedStorages.length > 0) {
            this.viewerStorages = connectedStorages;
            this.activateDefaultStorage();
            this.viewerLoading = false;
            await this.service.render();
            return;
        }

        const { code, data } = await this.callApi("viewer", { target_key: targetKey });
        if (code === 200) {
            this.viewerTarget = data?.target || target;
            this.viewerStorages = data?.storages || [];
            this.activateDefaultStorage();
        } else {
            this.viewerError = data?.message || data || this.translate.instant('page.log_policy.viewer_failed');
        }

        this.viewerLoading = false;
        await this.service.render();
    }

    public async closeViewer() {
        this.viewerOpen = false;
        this.viewerLoading = false;
        this.previewLoading = false;
        this.viewerError = '';
        this.previewError = '';
        this.viewerTarget = null;
        this.viewerTargetKey = '';
        this.viewerStorages = [];
        this.activeStorage = null;
        this.activeFile = null;
        this.clearPreview();
        await this.service.render();
    }

    public async toggleViewerStorages() {
        this.viewerStoragesCollapsed = !this.viewerStoragesCollapsed;
        await this.service.render();
    }

    public async toggleViewerFiles() {
        this.viewerFilesCollapsed = !this.viewerFilesCollapsed;
        await this.service.render();
    }

    public viewerGridColumns() {
        const storages = this.viewerStoragesCollapsed ? '48px' : '280px';
        const files = this.viewerFilesCollapsed ? '48px' : '320px';
        return `${storages} ${files} minmax(0, 1fr)`;
    }

    public async connectStorage(storage: any) {
        this.activeStorage = storage;
        this.activeFile = null;
        this.clearPreview();
        this.previewError = '';
        await this.service.render();
    }

    public isActiveStorage(storage: any) {
        return this.activeStorage?.key === storage?.key;
    }

    public isActiveFile(file: any) {
        return this.activeFile?.path === file?.path;
    }

    public async openPreview(file: any) {
        if (!this.viewerTargetKey || !this.activeStorage?.key || !file?.path) return;
        this.previewLoading = true;
        this.previewError = '';
        this.activeFile = file;
        this.clearPreview();
        await this.service.render();

        const { code, data } = await this.callApi("preview", {
            target_key: this.viewerTargetKey,
            storage: this.activeStorage.key,
            file: file.path,
        });
        if (code === 200) {
            this.setPreview(data || {});
        } else {
            this.previewError = data?.message || data || this.translate.instant('page.log_policy.preview_failed');
        }

        this.previewLoading = false;
        await this.service.render();
    }

    private clearPreview() {
        this.preview = null;
        this.previewMode = 'structured';
        this.previewFormat = '';
        this.previewRows = [];
        this.previewColumns = [];
    }

    private setPreview(data: any) {
        this.preview = data || {};
        this.previewFormat = String(this.preview?.format || '').trim();
        this.previewRows = Array.isArray(this.preview?.rows) ? this.preview.rows : [];
        this.previewColumns = Array.isArray(this.preview?.columns) ? this.preview.columns : [];

        if (this.previewRows.length === 0 && this.preview?.content) {
            const parsed = this.parsePreviewContent(this.preview);
            this.previewRows = parsed.rows;
            this.previewColumns = parsed.columns;
            this.previewFormat = this.previewFormat || parsed.format;
        }

        if (this.previewColumns.length === 0) {
            this.previewColumns = this.inferPreviewColumns(this.previewRows);
        }
        this.previewMode = this.hasStructuredPreview() ? 'structured' : 'raw';
    }

    private parsePreviewContent(preview: any) {
        const content = String(preview?.content || '');
        if (preview?.file?.kind === 'db') {
            try {
                const payload = JSON.parse(content);
                const rows = Array.isArray(payload?.rows) ? payload.rows : [];
                return { format: 'db', rows, columns: this.inferPreviewColumns(rows) };
            } catch (e) {
                return { format: 'text', rows: [], columns: [] };
            }
        }

        const rows: any[] = [];
        for (const line of content.split('\n')) {
            if (rows.length >= 120) break;
            const value = String(line || '').trim();
            if (!value.startsWith('{')) continue;
            try {
                const item = JSON.parse(value);
                if (item && typeof item === 'object' && !Array.isArray(item)) rows.push(item);
            } catch (e) {
                continue;
            }
        }
        return { format: rows.length > 0 ? 'jsonl' : 'text', rows, columns: this.inferPreviewColumns(rows) };
    }

    private inferPreviewColumns(rows: any[]) {
        const preferred = [
            'id', 'created', 'updated', 'started', 'completed', 'node_id', 'mac_address',
            'ip_address', 'action', 'status', 'method', 'message', 'target_type',
            'target_id', 'source', 'log'
        ];
        const columns: string[] = [];
        const seen: any = {};
        for (const key of preferred) {
            if ((rows || []).some((row: any) => row && Object.prototype.hasOwnProperty.call(row, key))) {
                columns.push(key);
                seen[key] = true;
            }
        }
        for (const row of rows || []) {
            for (const key of Object.keys(row || {})) {
                if (seen[key]) continue;
                columns.push(key);
                seen[key] = true;
                if (columns.length >= 18) return columns;
            }
        }
        return columns;
    }

    public hasStructuredPreview() {
        return this.previewRows.length > 0 && this.previewColumns.length > 0;
    }

    public setPreviewMode(mode: string) {
        this.previewMode = mode === 'raw' ? 'raw' : 'structured';
    }

    public previewFormatLabel() {
        if (this.previewFormat === 'db') return this.translate.instant('page.log_policy.preview_format_db');
        if (this.previewFormat === 'jsonl') return this.translate.instant('page.log_policy.preview_format_jsonl');
        return this.translate.instant('page.log_policy.preview_format_text');
    }

    public previewRowsLabel() {
        const shown = Number(this.preview?.shown ?? this.previewRows.length ?? 0);
        const count = this.preview?.count;
        if (count !== undefined && count !== null && count !== '') {
            return this.translate.instant('page.log_policy.preview_rows_shown', { shown, count: Number(count || 0) });
        }
        return this.translate.instant('page.log_policy.row_count', { count: shown });
    }

    public previewCell(row: any, column: string) {
        const value = row?.[column];
        if (value === null || value === undefined || value === '') return '-';
        if (typeof value === 'object') return JSON.stringify(value);
        return String(value);
    }

    public isStatusColumn(column: string) {
        return ['status', 'state', 'result'].includes(String(column || '').toLowerCase());
    }

    public statusBadgeClass(value: any) {
        const text = String(value || '').toLowerCase();
        let color = 'bg-zinc-100 text-zinc-700';
        if (text.includes('fail') || text.includes('error') || text.includes('cancel')) color = 'bg-rose-100 text-rose-700';
        else if (text.includes('complete') || text.includes('success') || text === 'done') color = 'bg-emerald-100 text-emerald-700';
        else if (text.includes('run') || text.includes('deploy') || text.includes('progress')) color = 'bg-sky-100 text-sky-700';
        else if (text.includes('pending') || text.includes('warn') || text.includes('review')) color = 'bg-amber-100 text-amber-700';
        return `inline-flex max-w-[180px] items-center rounded px-2 py-0.5 text-[11px] font-semibold ${color}`;
    }

    public fileSizeLabel(size: any) {
        const value = Number(size || 0);
        if (value >= 1024 * 1024) return `${(value / (1024 * 1024)).toFixed(1)} MB`;
        if (value >= 1024) return `${(value / 1024).toFixed(1)} KB`;
        return `${value} B`;
    }

    public fileMetaLabel(file: any) {
        if (file?.kind === 'db') {
            return this.translate.instant('page.log_policy.row_count', { count: Number(file?.count || 0) });
        }
        return this.fileSizeLabel(file?.size);
    }

    public retentionLabel(key: string) {
        const option = (this.options || []).find((item: any) => item.key === key);
        return option?.label || key || '-';
    }

    public async save() {
        this.saving = true;
        this.error = '';
        this.message = '';
        await this.service.render();

        const payload = {
            policies: this.policy || {},
            enabled: this.enabled || {},
            timeline_events: this.timelineEventEnabled || {},
            schedule_time: this.scheduleTime || '00:00',
        };
        const { code, data } = await this.callApi("save", { policy: JSON.stringify(payload) });
        if (code === 200) {
            this.policy = { ...(data?.policy?.policies || {}) };
            this.enabled = { ...(data?.policy?.enabled || {}) };
            this.timelineEvents = data?.timeline_events || this.timelineEvents;
            this.timelineEventEnabled = { ...(data?.policy?.timeline_events || {}) };
            this.scheduleTime = data?.policy?.schedule_time || '00:00';
            this.targets = data?.targets || this.targets;
            this.dirty = false;
            this.message = this.translate.instant('page.log_policy.saved');
        } else {
            this.error = data?.message || data || this.translate.instant('page.log_policy.save_failed');
        }

        this.saving = false;
        await this.service.render();
    }

    public async runCleanup() {
        if (!confirm(this.translate.instant('page.log_policy.confirm_cleanup'))) return;
        this.running = true;
        this.error = '';
        this.message = '';
        await this.service.render();

        const { code, data } = await this.callApi("run_cleanup");
        if (code === 200) {
            this.lastCleanup = data?.last_cleanup || data?.result || {};
            this.targets = data?.targets || this.targets;
            const deleted = data?.result?.deleted ?? this.lastCleanup?.deleted ?? 0;
            this.message = this.translate.instant('page.log_policy.cleanup_done', { count: deleted });
        } else {
            this.error = data?.message || data || this.translate.instant('page.log_policy.cleanup_failed');
        }

        this.running = false;
        await this.service.render();
    }

    public cleanupRows() {
        return this.lastCleanup?.results || [];
    }

    public cleanupTime() {
        return this.lastCleanup?.last_run_at || this.lastCleanup?.finished_at || '-';
    }

    public cleanupDeleted() {
        return Number(this.lastCleanup?.deleted || 0);
    }
}

export default PageKieraLogPolicyComponent;
